// import Vue from 'vue'
// import VueRouter from 'vue-router'
// Vue.use(VueRouter)

import Login from '../components/login/Login.vue'
import Home from '../components/home/Home.vue'
import MainAdmin from '../components/home/MainAdmin.vue'
import CompanyManager from '../components/home/manager/CompanyManager.vue'

import RoleManager from '../components/home/manager/RoleManager.vue';
import DeptManager from '../components/home/manager/DeptManager.vue';
import UserManager from '../components/home/manager/UserManager.vue';
import LoginLogManager from '../components/home/manager/LoginLogManager.vue';
import CompanyConfigManager from '../components/home/manager/CompanyConfigManager.vue';
import OperationLog from '../components/home/manager/OperationLog.vue';
import DataConfig from '../components/home/manager/DataConfig.vue'
import AppVersionManager from '../components/home/manager/AppVersionManager.vue'
import SystemMessageManager from '../components/home/manager/SystemMessageManager.vue'

import EquipmentManager from '../components/home/equipment/EquipmentManager.vue';
import EquipmentTypeManager from '../components/home/equipment/EquipmentTypeManager.vue';
import EquipmentFaultManager from '../components/home/equipment/EquipmentFaultManager.vue';
import EquipmentInfoManager from '../components/home/equipment/EquipmentInfoManager.vue';
import EquipmentLedgerHandlerManager from '../components/home/equipment/EquipmentLedgerHandlerManager.vue';
import EquipmentLedgerManager from '../components/home/equipment/EquipmentLedgerManager.vue';
import EquipmentOrderManager from '../components/home/equipment/EquipmentOrderManager.vue';

import Layout from '../components/home/process/comps/Layout.vue'
//首页
import Index1 from '../../dash/index.vue'
//首页-今日值班-新建
import JrzbAdd from '../../dash/components/JrzbAdd.vue'
// 首页-今日值班-查询
import JrzbSearch from '../../dash/components/JrzbSearch.vue'
//重大危险源监控
// import ProcessMonitoringList from '../components/home/process/ProcessMonitoringList'
//重大危险源监控===>数据管理
// import ProcessBaseInfo from '../components/home/process/ProcessBaseInfo'
// import ProcessSafeTic from '../components/home/process/ProcessSafeTic'
// import ProcessDangerInfo from '../components/home/process/ProcessDangerInfo'
//可燃有毒气体
// import ProcessDashBoard from '../components/home/process/ProcessDashBoard'
// import ProcessMonitor from '../components/home/process/ProcessMonitor'
// import ProcessMonitorDevice from '../components/home/process/ProcessMonitorDevice'
//风险分区管理
//四色图
// import ProcessAreaInfo from '../components/home/process/ProcessAreaInfo'
// import ProcessWarnArea from '../components/home/process/ProcessWarnArea'
//有害因素分类
// import ProcessHarm from '../components/home/process/ProcessHarm'
// 区域风险管理
// import RiskManagement from '../components/home/process/riskManagement/riskManagement'
// 区域风险管理里面的风险评价
// import RiskManagement from '../components/home/process/riskManagement/riskEvaluations'
// 区域风险管理风险点
// import ProcessRiskPoint from '../components/home/process/ProcessRiskPoint'
// 新增风险点
// import AddRiskPoint from '../components/home/process/comps/AddRiskPoint'
// 风险点辨识
// import AddriskPointIdentification from '../components/home/process/comps/AddriskPointIdentification'
// 风险点管控
// import AddRiskPointControl from '../components/home/process/comps/AddRiskPointControl'
//两单管理
// import ProcessTwoOrder from '../components/home/process/ProcessTwoOrder'// 废弃
// import twoOrderNew from '../components/home/process/ProcessTwoOrderNew'
//三卡管理
// import ProcessThreeCard from '../components/home/process/ProcessThreeCard'
//全流程安全生产
// import ProcessEmployee from '../components/home/process/ProcessEmployee'
// import ProcessArea from '../components/home/process/ProcessArea'
// import ProcessDepart from '../components/home/process/ProcessDepart'
// import ProcessDevice from '../components/home/process/ProcessDevice'
// import ProcessFace from '../components/home/process/ProcessFace'
// import ProcessVehicleManagement from '../components/home/process/ProcessVehicleManagement'
// import ProcessOrganizational from '../components/home/process/ProcessOrganizational'
// import ProcessContrac from '../components/home/process/ProcessContrac'
// import ProcessUploadFile from '../components/home/process/ProcessUploadFile'
// import Processlegislation from '../components/home/process/Processlegislation'
// import ProcessResource from "../components/home/process/ProcessResource"
// import ProcessSafety from '../components/home/process/ProcessSafety'
// import ProcessModelManagerment from '../components/home/process/ProcessModelManagerment'
// import ProcessEquAccount from '../components/home/process/ProcessEquAccount'
// import ProcessMaintenanceRecord from '../components/home/process/ProcessMaintenanceRecord'
// import ProcessChemicalInfo from '../components/home/process/ProcessChemicalInfo'
// import PeopleInOut from '../components/home/process/process_in_out/peopleInOut'
// import VehicleInOut from '../components/home/process/process_in_out/vehicleInOut'

// 目标责任管理
// import ProcessResponsibility from '../components/home/process/ProcessResponsibility'
// import ProcessTargetResponsibility from '../components/home/process/process_target_responsibility'

//教育培训
// import ProcessTraMaterial from '../components/home/process/ProcessTraMaterial'
// import ProcessTrainRecord from '../components/home/process/ProcessTrainRecord'
// import ProcessTrainRecord2 from '../components/home/process/ProcessTrainRecord2'
// import ProcessQuestion from '../components/home/process/ProcessQuestion'
// import ProcessExaminationQuestion from '../components/home/process/ProcessExaminationQuestion'
// import ProcessExamingRec from '../components/home/process/ProcessExamingRec'
// import ProcessExaminationQrcode from '../components/home/process/ProcessExaminationQrcode'
// import ProcessExaminationPaper from '../components/home/process/ProcessExaminationPaper'

//安全风险管控
// import ProcessRiskAnalysis from '../components/home/process/ProcessRiskAnalysis'
// import ProcessRisknotice from '../components/home/process/ProcessRisknotice'

//隐患排查治理
// import ProcessDangerType from '../components/home/process/ProcessDangerType'
// import ProcessDangerPlan from '../components/home/process/ProcessDangerPlan'
// import ProcessDangerTask from '../components/home/process/ProcessDangerTask'
// import ProcessDangerGovern from '../components/home/process/ProcessDangerGovern'

//应急管理
// import ProcessReservePlan from '../components/home/process/ProcessReservePlan'
// import ProcessDrillPlan from '../components/home/process/ProcessDrillPlan'
// import ProcessDrillEval from '../components/home/process/ProcessDrillEval'
// import PeocessMasterial from '../components/home/process/PeocessMasterial'

// import ProcessWorkPermit from '../components/home/process/ProcessWorkPermit'
// import ProcessWorkStatistics from '../components/home/process/ProcessWorkStatistics'
//巡检管理
// import ProcessInsRecord from '../components/home/process/ProcessInsRecord'
// import ProcessInsPath from '../components/home/process/ProcessInsPath'
// import ProcessInsPoint from '../components/home/process/ProcessInsPoint'
//事故管理
// import ProcessAccident from '../components/home/process/ProcessAccident'
// import ProcessAccidentRecord from '../components/home/process/ProcessAccidentRecord'
//变更管理
// import ProcessProductionList from '../components/home/process/ProcessProductionList'
// import ProcessProAccept from '../components/home/process/ProcessProAccept'
//考核评审管理
// import ProcessEvaluation from '../components/home/process/ProcessnewEvaluation'

//证书管理

// import ProcessCertificate from '../components/home/process/ProcessCertificate'

// import AddNewCard from '../components/home/process/comps/AddNewCard'
// import AddEmergeCard from '../components/home/process/comps/AddEmergeCard'
// import AddKnownCard from '../components/home/process/comps/AddKnownCard'
// import AddResponsibilityBook from '../components/home/process/comps/AddResponsibilityBook'
// import AddGolaPlan from '../components/home/process/comps/AddGolaPlan'
// import AddSafely from '../components/home/process/comps/AddSafely'
// import AddQuestion from '../components/home/process/comps/AddQuestion'
// import AddExamQuestion from '../components/home/process/comps/AddExamQuestion'
// import AddNewEmp from '../components/home/process/comps/AddNewEmp'
// import AddDepInfo from '../components/home/process/comps/AddDepInfo'

// import AddRoute from '../components/home/process/comps/AddRoute'

// import AddInsPath from '../components/home/process/comps/AddInsPath'
// import AddCerInfo from '../components/home/process/comps/AddCerInfo'
// import AddEvaInfo from '../components/home/process/comps/AddEvaInfo'
// import AddModiftList from '../components/home/process/comps/AddModiftList'

// import AddProAcc from '../components/home/process/comps/AddProAcc'
// import AddAccidenList from '../components/home/process/comps/AddAccidenList'
// import AddAccidentRec from '../components/home/process/comps/AddAccidentRec'
// import AddreservePlan from '../components/home/process/comps/AddreservePlan'
// import AddDriPlan from '../components/home/process/comps/AddDriPlan'
// import AddArea from '../components/home/process/comps/AddArea'

// import ShowEval from '../components/home/process/comps/ShowEval'
// import AddMaterial from '../components/home/process/comps/AddMaterial'
// import AddRiskAna from '../components/home/process/comps/AddRiskAna'
// import AddInsPoint from '../components/home/process/comps/AddInsPoint'
// import AddTrainReocrd from '../components/home/process/comps/AddTrainReocrd'
// import AddContrac from '../components/home/process/comps/AddContrac'
// import ProcessCompany from '../components/home/process/ProcessCompany'
// import AddTwoCardTwo from '../components/home/process/comps/AddTwoCardTwo'
// import AddTwoCardOne from '../components/home/process/comps/AddTwoCardOne'
// import AddEquAccount from '../components/home/process/comps/AddEquAccount'
// import AddChemicalInfo from '../components/home/process/comps/AddChemicalInfo'


// import Led from '../components/home/led/Led.vue';
// import ScodeExam from '../components/home/exam/ScodeExam';


const config = []
export default config
config.push({
    path: '/',
    component: Login
})
config.push({
    path: '/login',
    component: Login
})
config.push({
    path: '/home',
    component: Home
})
config.push({
    path: '/mainAdmin',
    component: MainAdmin,
    children: [
        { path: 'appVersionManager', component: AppVersionManager },
        { path: 'systemMessageManager', component: SystemMessageManager },
        { path: 'userManager', component: UserManager },
        { path: 'roleManager', component: RoleManager },
        { path: 'deptManager', component: DeptManager },
        { path: 'loginLog', component: LoginLogManager },
        { path: 'companyConfig', component: CompanyConfigManager },
        { path: 'dataConfig', component: DataConfig }
    ]
})
config.push({
    path: '/appVersionManager',
    component: AppVersionManager
})
config.push({
    path: '/led',
    component: () => import('../components/home/led/Led.vue')
})
config.push({
    path: '/designer',
    component: () => import('../../views/designer/designer')
})
config.push({
    path: '/map',
    component: () => import('../../views/map/map')
})

config.push({
    path: '/scodeExam',
    name: '/scodeExam',
    component: () => import('../components/home/exam/ScodeExam')
})
config.push({
    path: '/datav',
    component: () => import('../../views/datav'),
    name:'可视化大屏'
})
config.push({
    path: '/peoplePosition',
    component: () => import('../components/home/process/peopleManage/peoplePosition'),
    name:'人员定位大屏'
})
config.push({
    path: '/companyManager',
    component: CompanyManager,
    children: [{
        path: 'childCompanyManager',
        component: RoleManager
    },

        {
            path: 'companyConfig',
            component: CompanyConfigManager
        },
        {
            path: 'operationLog',
            component: OperationLog
        },
        {
            path: 'dataConfig',
            component: DataConfig
        },
        {
            path: 'appVersionManager',
            component: AppVersionManager
        },
        {
            path: 'deptManager',
            component: DeptManager
        },
        {
            path: 'loginLog',
            component: LoginLogManager
        },
        {
            path: 'roleManager',
            component: RoleManager
        },
        {
            path: 'userManager',
            component: UserManager
        },
    ]
})

config.push({
    path: '/equipmentManager',
    component: EquipmentManager,
    children: [{
        path: 'equipmentTypeManager',
        component: EquipmentTypeManager
    },
        {
            path: 'equipmentLedgerManager',
            component: EquipmentLedgerManager
        },
        {
            path: 'equipmentFaultManager',
            component: EquipmentFaultManager
        },
        {
            path: 'equipmentInfoManager',
            component: EquipmentInfoManager
        },
        {
            path: 'equipmentLedgerHandlerManager',
            component: EquipmentLedgerHandlerManager
        },
        {
            path: 'equipmentOrderManager',
            component: EquipmentOrderManager
        },
    ]
})

config.push({
    path: '/processManager',
    meta: {keepAlive: true},
    component: Layout,
    children: [{
        path: '/',
        component: Index1,
    }, {
        path: 'JrzbAdd',
        component: JrzbAdd
    }, {
        path: 'JrzbSearch',
        component: JrzbSearch
    }, {
        path: 'monitorList',
        component: () => import('../components/home/process/ProcessMonitoringList')
    }, {
        path: 'baseInfo',
        component: () => import('../components/home/process/ProcessBaseInfo')
    },
        // 流程模板
        {
            path: 'flowble',
            component: () => import('../../views/flowble/index')
        },
        // 单位流程
        {
            path: 'Department',
            component: () => import('../../views/flowble/Department')
        },
        // 代办流程
        {
            path: 'launch',
            component: () => import('../../views/flowble/launch')
        },
        // 代办详情
        {
            path: 'launchdetail',
            component: () => import('../../views/flowble/launchdetail')
        },
        // 已办流程
        {
            path: 'hasProcess',
            component: () => import('../../views/flowble/hasProcess')
        },
        // 我发起的
        {
            path: 'participate',
            component: () => import('../../views/flowble/participate')
        },
        // 我发起的详情
        {
            path: 'viewDetails',
            component: () => import('../../views/flowble/viewDetails')
        },
        {
            path: 'safeTic',
            component: () => import('../components/home/process/ProcessSafeTic')
        },
        {
            path: 'dangerInfo',
            component: () => import('../components/home/process/ProcessDangerInfo')
        },
        {
            path: 'dashBoard',
            component: () => import('../components/home/process/ProcessDashBoard')
        },
        {
            path: 'monitor',
            component: () => import('../components/home/process/ProcessMonitor')
        },
        {
            path: 'alertDataMonitor',
            component: () => import('../../views/major-hazard-monitoring/alertData/index.vue')
        },
        {
            path: 'monitorDevice',
            component: () => import('../components/home/process/ProcessMonitorDevice')
        },
        {
            path: 'areaInfo',
            component: () => import('../components/home/process/ProcessAreaInfo')
        },
        {
            path: 'areaInfo',
            component: () => import('../components/home/process/ProcessWarnArea')
        },
        {
            path: 'harm',
            component: () => import('../components/home/process/ProcessHarm')
        },
        {
            name: 'riskManagement',
            path: 'riskManagement',
            component: () => import('../components/home/process/riskManagement/riskManagement')
        },
        {
            path: 'ProcessRiskPoint',
            name: 'ProcessRiskPoint',
            component: () => import('../components/home/process/ProcessRiskPoint')
        },
        {
            path: 'riskPointDetail',
            name: 'riskPointDetail',
            component: () => import('../components/home/process/riskPointDetail')
        },
        {
            path: 'AddRiskPoint',
            name: 'AddRiskPoint',
            component: () => import('../components/home/process/comps/AddRiskPoint'),
        },
        {
            path: 'AddriskPointIdentification',
            name: 'AddriskPointIdentification',
            component: () => import('../components/home/process/comps/AddriskPointIdentification')
        },
        {
            path: 'riskIdentificationDetail',
            name: 'riskIdentificationDetail',
            component: () => import('../components/home/process/riskIdentificationDetail')
        },
        {
            path: 'AddRiskPointControl',
            name: 'AddRiskPointControl',
            component: () => import('../components/home/process/comps/AddRiskPointControl')
        },
        {
            path: 'riskControlDetail',
            name: 'riskControlDetail',
            component: () => import('../components/home/process/riskControlDetail')
        },
        {
            path: 'twoOrder',
            component: () => import('../components/home/process/ProcessTwoOrder')
        },
        {
            path: 'twoOrderNew',
            component: () => import('../components/home/process/ProcessTwoOrderNew')
        },
        {
            path: 'threeCard',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessThreeCard')
        },
        {
            path: 'employee',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessEmployee')
        },
        {
            path: 'ProcessPersonCharge',
            name: 'ProcessPersonCharge',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessPersonCharge')
        },
        {
            path: 'AddPersonCharge',
            name: 'AddPersonCharge',
            component: () => import('../components/home/process/comps/AddPersonCharge')
        },
        {
            path: 'device',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDevice')
        },
        {
            path: 'warningSign',
            name: 'warningSign',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/warningSign')
        },
        {
            path: 'AddWarningSign',
            name: 'AddWarningSign',
            component: () => import('../components/home/process/comps/AddWarningSign')
        },
        {
            path: 'face',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessFace')
        },
        {
            path: 'organizational',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessOrganizational')
        },
        {
            path: 'modelManagerment',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessModelManagerment')
        },
        {
            path: 'maintenanceRecord',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessMaintenanceRecord')
        },
        {
            path: 'AddMaintenanceRecord',
            name: 'AddMaintenanceRecord',
            component: () => import('../components/home/process/comps/AddMaintenanceRecord')
        },
        {
            path: 'peopleInOut',
            component: () => import('../components/home/process/peopleManage/peopleInOut'),
            name:'人员出入'
        },
        {
            path: 'vehicleInOut',
            component: () => import('../components/home/process/peopleManage/vehicleInOut'),
            name:'车辆出入'
        },
        {
            path: 'peoplePosition',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/peopleManage/peoplePosition'),
            name:'人员定位'
        },
        {
            path: 'equAccount',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessEquAccount')
        },
        {
            path: 'AddEquAccount',
            component: () => import('../components/home/process/comps/AddEquAccount')
        },
        {
            path: 'AddChemicalInfo',
            component: () => import('../components/home/process/comps/AddChemicalInfo')
        },
        {
            path: 'chemicalInfo',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessChemicalInfo')
        },
        {
            path: 'ProcessInformation',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessInformation')
        },
        {
            path: 'AddProcessInformation',
            name: 'AddProcessInformation',
            component: () => import('../components/home/process/comps/AddProcessInformation')
        },
        {
            path: 'flowChart',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/flowChart')
        },
        {
            path: 'AddFlowChart',
            name: 'AddFlowChart',
            component: () => import('../components/home/process/comps/AddFlowChart')
        },
        {
            path: 'ProcessPubEngineering',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessPubEngineering')
        },
        {
            path: 'AddPubEngineering',
            name: 'AddPubEngineering',
            component: () => import('../components/home/process/comps/AddPubEngineering')
        },
        {
            path: 'ProcessEvnInfo',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessEvnInfo')
        },
        {
            path: 'AddEvnInfo',
            name: 'AddEvnInfo',
            component: () => import('../components/home/process/comps/AddEvnInfo')
        },
        {
            path: 'vehicleManagement',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessVehicleManagement')
        },
        {
            path: 'depart',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDepart')
        },
        {
            path: 'ProcessPost',
            component: () => import('../components/home/process/ProcessPost')
        },
        {
            path: 'contrac',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessContrac')
        },
        {
            path: 'supplierManager',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/supplierManager')
        },
        {
            path: 'AddSupplierManager',
            name: 'AddSupplierManager',
            component: () => import('../components/home/process/comps/AddSupplierManager')
        },
        {
            path: 'uploadFile',
            component: () => import('../components/home/process/ProcessUploadFile')
        },
        {
            path: 'resource',
            component: () => import('../components/home/process/ProcessResource')
        },
        {
            path: 'legislation',
            component: () => import('../components/home/process/Processlegislation')
        },
        {
            path: 'AddLegislation',
            name: 'AddLegislation',
            component: () => import('../components/home/process/comps/AddLegislation')
        },
        {
            path: 'targetResponsibility',
            component: () => import('../components/home/process/process_target_responsibility'),
            name: 'responsibility',
            children: [
                //禁用开始
                {
                    path: 'standardList',
                    name: 'standardList',
                    meta:{keepAlive:true},
                    component: () => import('../components/home/process/process_target_responsibility/target/standardList')
                },
                {
                    path: 'standardAdd',
                    name: 'standardAdd',
                    component: () => import('../components/home/process/process_target_responsibility/target/standardAdd')
                },
                {
                    path: 'standardDetail/:id',
                    name: 'standardDetail',
                    component: () => import('../components/home/process/process_target_responsibility/target/standardDetail')
                },
                {
                    path: 'mainTarget',
                    name: 'mainTarget',
                    meta:{keepAlive:true},
                    component: () => import('../components/home/process/process_target_responsibility/target/mainTarget')
                },
                {
                    path: 'mainTargetAdd',
                    name: 'mainTargetAdd',
                    component: () => import('../components/home/process/process_target_responsibility/target/mainTargetAdd')
                },
                {
                    path: 'mainTargetDetail/:id',
                    name: 'mainTargetDetail',
                    component: () => import('../components/home/process/process_target_responsibility/target/mainTargetDetail')
                },
                {
                    path: 'rectifyTarget',
                    name: 'rectifyTarget',
                    meta:{keepAlive:true},
                    component: () => import('../components/home/process/process_target_responsibility/target/rectifyTarget')
                },
                {
                    path: 'rectifyTargetAdd',
                    name: 'rectifyTargetAdd',
                    component: () => import('../components/home/process/process_target_responsibility/target/rectifyTargetAdd')
                },
                {
                    path: 'rectifyDetail/:id',
                    name: 'rectifyDetail',
                    component: () => import('../components/home/process/process_target_responsibility/target/rectifyDetail')
                },
                {
                    path: 'targetSplit',
                    name: 'targetSplit',
                    meta:{keepAlive:true},
                    component: () => import('../components/home/process/process_target_responsibility/target/targetSplit')
                },
                {
                    path: 'targetSplitAdd',
                    name: 'targetSplitAdd',
                    component: () => import('../components/home/process/process_target_responsibility/target/targetSplitAdd')
                },
                {
                    path: 'splitDetail/:id',
                    name: 'splitDetail',
                    component: () => import('../components/home/process/process_target_responsibility/target/splitDetail')
                },
                {
                    path: 'checkTarget',
                    name: 'checkTarget',
                    meta:{keepAlive:true},
                    component: () => import('../components/home/process/process_target_responsibility/target/checkTarget')
                },
                {
                    path: 'checkTargetAdd',
                    name: 'checkTargetAdd',
                    component: () => import ('../components/home/process/process_target_responsibility/target/checkTargetAdd')
                },
                {
                    path: 'checkTargetDetail/:id',
                    name: 'checkTargetDetail',
                    component: () => import('../components/home/process/process_target_responsibility/target/checkTargetDetail')
                },
                //禁用结束
                {
                    path: 'position',
                    name: 'position',
                    meta: {keepAlive: true},
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/position')
                },
                {
                    path: 'positionAdd',
                    name: 'positionAdd',
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/positionAdd')
                },
                {
                    path: 'positionDetail/:id',
                    name: 'positionDetail',
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/positionDetail')
                },
                {
                    path: 'personal',
                    name: 'personal',
                    meta: {keepAlive: true},
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/personal')
                },
                {
                    path: 'personalAdd',
                    name: 'personalAdd',
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/personalAdd')
                },
                {
                    path: 'personalDetail/:id',
                    name: 'personalDetail',
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/personalDetail')
                },
                {
                    path: 'goalExamineStatistics',
                    meta: {keepAlive: true},
                    component: () => import('../components/home/process/process_target_responsibility/responsibility/goalExamineStatistics')
                }
            ]
        },
        {
            path: 'safety',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessSafety')
        },
        {
            path: 'traMaterial',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessTraMaterial')
        },
        {
            path: 'trainRecord',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessTrainRecord')

        },
        {
            path: 'trainRecord2',
            component: () => import('../components/home/process/ProcessTrainRecord2')
        },
        {
            path: 'safetyActivityInfo',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/safetyActivityInfo')
        },
        {
            path: 'AddSafetyActivity',
            name: 'AddSafetyActivity',
            component: () => import('../components/home/process/comps/AddSafetyActivity')
        },
        {
            path: 'question',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessQuestion')
        },
        {
            path: 'examinationQuestion',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessExaminationQuestion')
        },
        {
            path: 'examingRec',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessExamingRec')
        },
        {
            path: 'examRecDetail',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/examRecDetail')
        },
        {
            path: 'userExamDetail',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/userExamDetail')
        },
        {
            path: 'examinationQrcode',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessExaminationQrcode')
        },
        {
            path: 'examinationPaper',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessExaminationPaper')
        },
        {
            path: 'riskAnalysis',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessRiskAnalysis')
        },
        {
            name: 'risknotice',
            path: 'risknotice',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessRisknotice')
        },
        {
            path: 'dangerType',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDangerType')
        },
        {
            path: 'dangerPlan',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDangerPlan')
        },
        {
            path: 'ProcessStatistics',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessStatistics')
        },
        {
            path: 'ProcessTeamGroup',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessTeamGroup')
        },
        {
            path: 'dangerTask',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDangerTask')
        },
        {
            path: 'dangerTaskList',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDangerTaskList')
        },
        {
            name: 'dangerGovern',
            path: 'dangerGovern',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDangerGovern')
        },
        {
            path: 'reservePlan',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessReservePlan')
        },
        {
            path: 'meetEmergencyRanks',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/meetEmergencyRanks')
        },
        {
            path: 'AddMeetEmergencyRanks',
            name: 'AddMeetEmergencyRanks',
            component: () => import('../components/home/process/comps/AddMeetEmergencyRanks')
        },
        {
            path: 'drillPlan',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDrillPlan')
        },
        {
            path: 'drillEval',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessDrillEval')
        },
        {
            path: 'masterial',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/PeocessMasterial')
        },
        {
            path: 'addMasterialRecord',
            name: 'addMasterialRecord',
            component: () => import('../components/home/process/comps/AddPeocessMasterialRocord')
        },
        {
            path: 'workPermit',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessWorkPermit')
        },
        {
            path: 'workStatistics',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessWorkStatistics')
        },
        {
            path: 'insRecord',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessInsRecord')
        },
        {
            path: 'insPath',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessInsPath')
        },
        {
            path: 'insPoint',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessInsPoint')
        },
        {
            path: 'accident',
            component: () => import('../components/home/process/ProcessAccident')
        },
        {
            path: 'accidentRecord',
            component: () => import('../components/home/process/ProcessAccidentRecord')
        },
        {
            path: 'InjuryOnTheJob',
            component: () => import('../components/home/process/InjuryOnTheJob')
        },
        {
            path: 'AddInjuryOnTheJob',
            name: 'AddInjuryOnTheJob',
            component: () => import('../components/home/process/comps/AddInjuryOnTheJob')
        },
        {
            path: 'productionList',
            component: () => import('../components/home/process/ProcessProductionList')
        },
        {
            path: 'proAccept',
            component: () => import('../components/home/process/ProcessProAccept')
        },
        {
            path: 'evaluation',
            component: () => import('../components/home/process/ProcessnewEvaluation')
        },
        {
            path: 'certificate',
            component: () => import('../components/home/process/ProcessCertificate')
        },
        {
            path: 'projectThree',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/projectThree')
        },
        {
            path: 'addProjectThree',
            name: 'addProjectThree',
            component: () => import('../components/home/process/comps/AddProjectThree')
        },
        {
            path: 'collectInfo',
            component: () => import('../components/home/process/collectInfo')
        },
        {
            path: 'connectInfo',
            component: () => import('../components/home/process/connectInfo')
        },
        {
            path: 'AddEquipment',
            name: 'AddEquipment',
            component: () => import('../components/home/process/comps/AddEquipment')
        },
        {
            path: 'AddCollectPoint',
            name: 'AddCollectPoint',
            component: () => import('../components/home/process/comps/AddCollectPoint')
        },
        {
            path: 'editer',
            name: 'addEditer',
            component: () => import('../components/home/process/comps/AddNewCard')
        },
        {
            path: 'addEmerger',
            name: 'addEmerger',
            component: () => import('../components/home/process/comps/AddEmergeCard')
        },
        {
            path: 'addknowCard',
            name: 'addknowCard',
            component: () => import('../components/home/process/comps/AddKnownCard')
        },
        {
            path: 'addNewEmp',
            name: 'addNewEmp',
            component: () => import('../components/home/process/comps/AddNewEmp')
        },
        {
            path: 'addDepInfo',
            name: 'addDepInfo',
            component: () => import('../components/home/process/comps/AddDepInfo')
        },
        {
            path: 'addRoute',
            name: 'addRoute',
            component: () => import('../components/home/process/comps/AddRoute')
        },
        {
            path: 'addInsPath',
            name: 'addInsPath',
            component: () => import('../components/home/process/comps/AddInsPath')
        },
        {
            path: 'addCerInfo',
            name: 'addCerInfo',
            component: () => import('../components/home/process/comps/AddCerInfo')
        },
        {
            path: 'addGolaPlan',
            name: 'addGolaPlan',
            component: () => import('../components/home/process/comps/AddGolaPlan')
        },
        {
            path: 'addSafely',
            name: 'addSafely',
            component: () => import('../components/home/process/comps/AddSafely')
        },
        {
            path: 'addQuestion',
            name: 'addQuestion',
            component: () => import('../components/home/process/comps/AddQuestion')
        },
        {
            path: 'addEvaInfo',
            name: 'addEvaInfo',
            component: () => import('../components/home/process/comps/AddEvaInfo')
        },
        {
            path: 'addModiftList',
            name: 'addModiftList',
            component: () => import('../components/home/process/comps/AddModiftList')
        },
        {
            path: 'addProAcc',
            name: 'addProAcc',
            component: () => import('../components/home/process/comps/AddProAcc')
        },
        {
            path: 'addAccidenList',
            name: 'addAccidenList',
            component: () => import('../components/home/process/comps/AddAccidenList')
        },
        {
            path: 'addAccidentRec',
            name: 'addAccidentRec',
            component: () => import('../components/home/process/comps/AddAccidentRec')
        },
        {
            path: 'addreservePlan',
            name: 'addreservePlan',
            component: () => import('../components/home/process/comps/AddreservePlan')
        },
        {
            path: 'addDriPlan',
            name: 'addDriPlan',
            component: () => import('../components/home/process/comps/AddDriPlan')
        },
        {
            path: 'showEval', // 这个弃用
            name: 'showEval',
            component: () => import('../components/home/process/comps/ShowEval')
        },
        {
            path: 'AddDrillEva/:id',
            name: 'AddDrillEva',
            component: () => import('../components/home/process/comps/AddDrillEva')
        },
        {
            path: 'addMaterial',
            name: 'addMaterial',
            component: () => import('../components/home/process/comps/AddMaterial')
        },
        {
            path: 'addRiskAna',
            name: 'addRiskAna',
            component: () => import('../components/home/process/comps/AddRiskAna')
        },

        {
            path: 'addresponsibilityBook',
            name: 'addresponsibilityBook',
            component: () => import('../components/home/process/comps/AddResponsibilityBook')
        },
        // {
        //   path: 'addGolaPlan',
        //   name: 'addGolaPlan',
        //   component: AddGolaPlan
        // },
        // {
        //   path: 'addSafely',
        //   name: 'addSafely',
        //   component: AddSafely
        // },
        // {
        //   path: 'addQuestion',
        //   name: 'addQuestion',
        //   component: AddQuestion
        // },

        {
            path: 'addExamQuestion',
            name: 'addExamQuestion',
            component: () => import('../components/home/process/comps/AddExamQuestion')
        },
        {
            path: 'addInsPoint',
            name: 'AddInsPoint',
            component: () => import('../components/home/process/comps/AddInsPoint')
        },
        {
            path: 'addTrainReocrd',
            name: 'addTrainReocrd',
            component: () => import('../components/home/process/comps/AddTrainReocrd')
        },

        {
            path: 'processArea',
            name: 'processArea',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessArea')
        },
        {
            path: 'addArea',
            name: 'addArea',
            component: () => import('../components/home/process/comps/AddArea')
        },
        {
            path: 'ProcessRawMaterials',
            name: 'ProcessRawMaterials',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessRawMaterials')
        },
        {
            path: 'AddRawMaterials',
            name: 'AddRawMaterials',
            component: () => import('../components/home/process/comps/AddRawMaterials')
        },
        {
            path: 'ProcessMidProducts',
            name: 'ProcessMidProducts',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessMidProducts')
        },
        {
            path: 'ProcessEndProducts',
            name: 'ProcessEndProducts',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessEndProducts')
        },
        {
            path: 'addContrac',
            name: 'addContrac',
            component: () => import('../components/home/process/comps/AddContrac')
        },
        {
            path: 'company',
            meta: {keepAlive: true},
            component: () => import('../components/home/process/ProcessCompany')
        },
        {
            path: 'addTwoCardTwo',
            name: 'addTwoCardTwo',
            component: () => import('../components/home/process/comps/AddTwoCardTwo')
        },
        {
            path: 'addTwoCardOne',
            name: 'addTwoCardOne',
            component: () => import('../components/home/process/comps/AddTwoCardOne')
        },
        {
            path: 'viewMonitor',
            name: 'viewMonitor',
            meta: {keepAlive: true},
            component: () => import('../../views/control/index')
        },
        {
            path: 'viewMap',
            name: 'viewMap',
            component: () => import('../../views/control/map/map')
        },
        {
            path: 'earlyWarning',
            name: 'earlyWarning',
            component: () => import('../../views/control/earlyWarning/index')
        },
        {
            path: 'map',
            name: 'map',
            component: () => import('../../views/control/map/map')
        },
        // 人员在岗在位
        {
            path: 'peopleOnline',
            name: 'peopleOnline',
            meta: {keepAlive: true},
            component: () => import('../../views/peopleOnline')
        },
        //  装置信息
        {
            path: 'deviceInfo',
            name: 'deviceInfo',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/device')
        },
        {
            path: 'deviceEdit',
            name: 'deviceEdit',
            component: () => import('../../views/major-hazard-monitoring/device/edit')
        },
        // //  表征参数
        // {
        //   path: 'paramsInfo',
        //   name: 'paramsInfo',
        //   component: () => import('../../views/major-hazard-monitoring/params')
        // },
        // {
        //   path: 'paramsEdit',
        //   name: 'paramsEdit',
        //   component: () => import('../../views/major-hazard-monitoring/params/edit')
        // },
        // //  储罐信息
        // {
        //   path: 'tankInfo',
        //   name: 'tankInfo',
        //   component: () => import('../../views/major-hazard-monitoring/tank/tankInfo')
        // },
        // {
        //   path: 'tankEdit',
        //   name: 'tankEdit',
        //   component: () => import('../../views/major-hazard-monitoring/tank/tankEdit')
        // },
        // //  储罐指标
        // {
        //   path: 'tankTarget',
        //   name: 'tankTarget',
        //   component: () => import('../../views/major-hazard-monitoring/tank/tankTarget')
        // },
        // {
        //   path: 'tankTargetEdit',
        //   name: 'tankTargetEdit',
        //   component: () => import('../../views/major-hazard-monitoring/tank/tankTargetEdit')
        // },
        //  重大危险源信息
        {
            path: 'majorHazard',
            name: 'majorHazard',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/major')
        },
        {
            path: 'majorHazardEdit',
            name: 'majorHazardEdit',
            component: () => import('../../views/major-hazard-monitoring/major/edit')
        },
        // 仓库区域
        {
            path: 'warehouseArea',
            name: 'warehouseArea',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/warehouseArea')
        },
        {
            path: 'warehouseAreaEdit',
            name: 'warehouseAreaEdit',
            component: () => import('../../views/major-hazard-monitoring/warehouseArea/edit')
        },
        // 库房信息
        {
            path: 'storehouse',
            name: 'storehouse',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/storehouse')
        },
        {
            path: 'storehouseEdit',
            name: 'storehouseEdit',
            component: () => import('../../views/major-hazard-monitoring/storehouse/edit')
        },
        // 储罐区域
        {
            path: 'storageTank',
            name: 'storageTank',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/storageTank')
        },
        {
            path: 'storageTankEdit',
            name: 'storageTankEdit',
            component: () => import('../../views/major-hazard-monitoring/storageTank/edit')
        },
        {
            path: 'storageTankInfo',
            name: 'storageTankInfo',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/storageTank/tankInfo')
        },
        {
            path: 'storageTankInfoEdit',
            name: 'storageTankInfoEdit',
            component: () => import('../../views/major-hazard-monitoring/storageTank/tankInfo/edit')
        },
        // 连锁管理
        {
            path: 'interlocking',
            name: 'interlocking',
            meta: {keepAlive: true},
            component: () => import('../../views/major-hazard-monitoring/interlocking')
        },
        {
            path: 'interlockingEdit',
            name: 'interlockingEdit',
            component: () => import('../../views/major-hazard-monitoring/interlocking/edit')
        },
        // 工作台 - 部署
        {
            path: 'workflowDeploy',
            name: 'workflowDeploy',
            meta: {keepAlive: true},
            component: () => import('../../views/workStation/workflowDeploy')
        },
        // 工作台 - 工作流程
        {
            path: 'workflowApply',
            name: 'workflowApply',
            meta: {keepAlive: true},
            component: () => import('../../views/workStation/workflowApply')
        },

        // 工作台 - 待办
        {
            path: 'workNeedDealtWith',
            name: 'workNeedDealtWith',
            meta: {keepAlive: true},
            component: () => import('../../views/workStation/workflowNeedDealtWidth')
        },
        {
            path: 'nvrAlarm',
            name: '视频监控报警',
            component: () => import('../components/home/process/ProcessNvrAlarm')
        },
        {
            path: 'safechart',
            name: '安全风险四色图',
            component: () => import('../components/home/doublePrevention/Safechart')
        },
        {
            path: 'riskObject',
            name: '风险分析对象',
            component: () => import('../components/home/doublePrevention/RiskObject')
        },
        {
            path: 'riskInfo',
            name: '安全风险信息',
            component: () => import('../components/home/doublePrevention/RiskInfo')
        },
        {
            path: 'riskUtil',
            name: '风险分析单元',
            component: () => import('../components/home/doublePrevention/RiskUnit')
        },
        {
            path: 'dangersrc',
            name: '危险源信息',
            component: () => import('../components/home/doublePrevention/Dangersrc')
        },
        {
            path: 'riskDist',
            name: '安全风险辨识记录',
            component: () => import('../components/home/doublePrevention/RiskDist')
        },
        {
            path: 'riskCtrl',
            name: '管控措施信息',
            component: () => import('../components/home/doublePrevention/RiskCtrl')
        },
        {
            path: 'riskUtilStop',
            name: '装置停用/检维修记录',
            component: () => import('../components/home/doublePrevention/RiskUnitStop')
        },
        {
            path: 'dataConfiguration',
            name: '上传信息配置',
            component: () => import('../components/home/doublePrevention/DataConfiguration')
        },
        {
            path: 'deviceManager',
            name: '装置管理',
            component: () => import('../components/home/doublePrevention/DeviceManager.vue')
        },
        {
            path: 'bDuty',
            name: '包保责任管理',
            component: () => import('../components/home/doublePrevention/BDuty.vue')
        },
        {
            path: 'bPlan',
            name: '包保任务管理',
            component: () => import('../components/home/doublePrevention/BPlan.vue')
        },
        {
            path: 'bTaskList',
            name: '包保责任任务管理',
            component: () => import('../components/home/doublePrevention/BTaskList.vue')
        },
        {
            path: 'bTaskStatistics',
            name: '包保责任任务统计',
            component: () => import('../components/home/doublePrevention/BTaskStatistics.vue')
        },
        {
            path: 'bTaskSearchRecord',
            name: '包保责任任务查询排查记录',
            component: () => import('../components/home/doublePrevention/BTaskSearchRecord.vue')
        },
        {
            path: 'rewardPunishmentRules',
            name: '奖惩制度规则',
            component: () => import('../components/home/doublePrevention/RewardPunishmentRules.vue')
        },
        {
            path: 'rewardPunishment',
            name: '奖惩制度统计',
            component: () => import('../components/home/doublePrevention/RewardPunishment.vue')
        },
        {
            path: 'Pingram',
            name: '违规照片',
            component: () => import('../components/home/pingram/Pingram.vue')
        },
        {
            path: 'tbBaseCheckItem',
            name: '专项检查项',
            component: () => import('../components/home/specialExamination/item.vue')
        },
        {
            path: 'tbBaseCheckRecord',
            name: '检查情况记录',
            component: () => import('../components/home/specialExamination/record.vue')
        },
        {
            path: 'tbBaseCheckScore',
            name: '检查项评分细则',
            component: () => import('../components/home/specialExamination/score.vue')
        },
        {
            path: 'tbBaseCheckTask',
            name: '检查任务',
            component: () => import('../components/home/specialExamination/task.vue')
        },
        {
            path: 'tbBaseSpecialDanger',
            name: '专项检查情况记录',
            component: () => import('../components/home/specialExamination/specialDanger.vue')
        },
        {
            path: 'tbWorkPermitReport',
            name: '特殊作业活动报备',
            component: () => import('../components/home/baseDate/TbWorkPermitReport.vue')
        },
        {
            path: 'tbWorkPermitData',
            name: '特殊作业活动信息',
            component: () => import('../components/home/baseDate/TbWorkPermitData.vue')
        },
        {
            path: 'tbWorkPermitInfo',
            name: '特殊作业证信息',
            component: () => import('../components/home/baseDate/TbWorkPermitInfo.vue')
        },
        {
            path: 'verDate',
            name: '气体检测',
            component: () => import('../components/home/verDate/verDate.vue')
        },
        {
            path: 'videoDate',
            name: '视频监控',
            component: () => import('../components/home/videoDate/videoDate.vue')
        },
        {
            path: 'AlarmClassification',
            name: '报警分级管理',
            component: () => import('../components/home/alarmClassification/AlarmClassification.vue')
        },
        {
            path: 'tbDangerTask',
            name: '超期任务',
            component: () => import('../components/home/overdue/DangerTask.vue')
        },
        {
            path: 'tbDangerGovern',
            name: '超期隐患',
            component: () => import('../components/home/overdue/DangerGovern.vue')
        }
    ]
},)
